// ─── Coordinate system ────────────────────────────────────────────────────────
export const WORLD_SNAP   = 100;
export const GRID_PX      = 20;
export const WORLD_SCALE  = GRID_PX / WORLD_SNAP;
export const EPS          = 1e-9;
export const CELL_SIZE    = 1000;
export const MIN_AREA_MM2 = 250000;
export const MICRO_EDGE   = 50;
export const NODE_MERGE_D = 60;   // < WORLD_SNAP(100mm): merges float near-misses, never adjacent grid cells

// ─── Snap distances ───────────────────────────────────────────────────────────
export const SNAP_NODE = 200;
export const SNAP_EDGE = 80;
export const SNAP_MID  = 120;
export const SNAP_IX   = 100;
export const SNAP_LOCK = 300;

// ─── Materials ────────────────────────────────────────────────────────────────
export const MATERIALS = {
  BRICK:     { id:"BRICK",     name:"Brick Masonry",    thickness:230, rateM3:4500, color:"#8B4513", bricksPerM3:500, cementBagsPerM3:1.6, sandCftPerM3:4.5  },
  AAC:       { id:"AAC",       name:"AAC Block",        thickness:200, rateM3:3800, color:"#C0C0C0", bricksPerM3:0,   cementBagsPerM3:0.8, sandCftPerM3:2.0  },
  HOLLOW:    { id:"HOLLOW",    name:"Hollow Block",     thickness:200, rateM3:3200, color:"#A9A9A9", bricksPerM3:0,   cementBagsPerM3:0.9, sandCftPerM3:2.5  },
  PARTITION: { id:"PARTITION", name:"Drywall Partition",thickness:100, rateM3:2800, color:"#E8E8D0", bricksPerM3:0,   cementBagsPerM3:0,   sandCftPerM3:0    },
  GLASS:     { id:"GLASS",     name:"Glass Partition",  thickness:12,  rateM2:8500, color:"#B0D0FF", bricksPerM3:0,   cementBagsPerM3:0,   sandCftPerM3:0    },
  RC:        { id:"RC",        name:"RC / Concrete",    thickness:150, rateM3:7500, color:"#969696", bricksPerM3:0,   cementBagsPerM3:7.0, sandCftPerM3:14   },
};

export const DEFAULT_H = 3000;
export const LABOUR    = 0.25;

// ─── Room templates ───────────────────────────────────────────────────────────
export const ROOM_TEMPLATES = {
  ROOM:     { label:"Room",        icon:"⬜", floorR:1200, wallR:350 },
  BEDROOM:  { label:"Bedroom",     icon:"🛏", floorR:1400, wallR:380 },
  LIVING:   { label:"Living Room", icon:"🛋", floorR:1600, wallR:420 },
  KITCHEN:  { label:"Kitchen",     icon:"🍳", floorR:1800, wallR:600 },
  BATHROOM: { label:"Bathroom",    icon:"🚿", floorR:2200, wallR:900 },
  TOILET:   { label:"Toilet",      icon:"🚽", floorR:2000, wallR:850 },
  STORE:    { label:"Store",       icon:"📦", floorR:800,  wallR:280 },
  CORRIDOR: { label:"Corridor",    icon:"🚶", floorR:1100, wallR:320 },
  OFFICE:   { label:"Office",      icon:"💼", floorR:1500, wallR:450 },
  BALCONY:  { label:"Balcony",     icon:"🌿", floorR:900,  wallR:260 },
};

export const ROOM_COLORS = {
  ROOM:"#1a2030", BEDROOM:"#1a2030", LIVING:"#1c2418", KITCHEN:"#241c18",
  BATHROOM:"#181c28", TOILET:"#181c28", STORE:"#1c1c1c", CORRIDOR:"#1e1e24",
  OFFICE:"#1a2030", BALCONY:"#181e18",
};

export const ROOM_STROKES = {
  ROOM:"#4ade80", BEDROOM:"#60a5fa", LIVING:"#a3e635", KITCHEN:"#fb923c",
  BATHROOM:"#22d3ee", TOILET:"#67e8f9", STORE:"#9ca3af", CORRIDOR:"#c4b5fd",
  OFFICE:"#f9a8d4", BALCONY:"#86efac",
};

// ─── Opening presets ──────────────────────────────────────────────────────────
export const OPENING_PRESETS = {
  DOOR_STD:  { label:"Door 900×2100",    width:900,  height:2100, sillHeight:0   },
  DOOR_WIDE: { label:"Door 1200×2100",   width:1200, height:2100, sillHeight:0   },
  WIN_STD:   { label:"Window 1200×1200", width:1200, height:1200, sillHeight:900 },
  WIN_FULL:  { label:"Window 1800×1200", width:1800, height:1200, sillHeight:900 },
  WIN_SMALL: { label:"Window 600×600",   width:600,  height:600,  sillHeight:1200},
};
